import { HStack } from "@chakra-ui/react";
import { DataTable, NavBar } from "@components/ui-kit";
import { Pagination } from "@components/ui-kit/table/pagination";
import { Trans, t } from "@lingui/macro";
import { BrandsWhereColumn } from "@src/__generated__/urql-graphql";
import { FiltersPanel } from "@src/utils/components/filters/components/filters-panel";
import { can } from "@src/utils/components/permissions";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useContext } from "react";
import { AddBtn } from "./common";
import { PageBrandsCtx } from "./PageBrands";
import { QuickFilters } from "./StoreBrands";
import { TableBrands } from "./table/TableBrands";

export const CardListBrands = observer(function CardListBrands() {
  const store = useContext(PageBrandsCtx);

  const state = useLocalObservable(() => ({
    get activeFilter() {
      return store.where.filters.find(
        (f) => f.column === BrandsWhereColumn.Status,
      );
    },
  }));

  return (
    <DataTable>
      <DataTable.NavBar>
        <HStack justifyContent="space-between">
          <NavBar>
            <NavBar.Item
              active={store.activeQuickFilter?.value?.[0] === QuickFilters.All}
              onClick={() => {
                state.activeFilter?.clear();
                store.activeQuickFilter?.setValue(QuickFilters.All);
              }}
            >
              <Trans>All</Trans>
            </NavBar.Item>
            <NavBar.Item
              active={
                store.activeQuickFilter?.value?.[0] === QuickFilters.Active
              }
              onClick={() => {
                state.activeFilter?.setValue(QuickFilters.Active);
                store.activeQuickFilter?.setValue(QuickFilters.Active);
              }}
            >
              <Trans>Active</Trans>
            </NavBar.Item>
            <NavBar.Item
              active={
                store.activeQuickFilter?.value?.[0] === QuickFilters.Archived
              }
              onClick={() => {
                state.activeFilter?.setValue(QuickFilters.Archived);
                store.activeQuickFilter?.setValue(QuickFilters.Archived);
              }}
            >
              <Trans>Archived</Trans>
            </NavBar.Item>
          </NavBar>
          <HStack spacing="3">
            {can("client_create", "brand_create") && <AddBtn />}
          </HStack>
        </HStack>
      </DataTable.NavBar>

      <DataTable.Filter>
        <FiltersPanel<BrandsWhereColumn>
          filters={store.where}
          searchPlaceholder={t`Search by brand, client, contact person`}
          searchDefaultValue={store.searchTerm}
          onSearch={(val) => {
            store.searchTerm = val;
            store.pagination.resetPage();
          }}
        />
      </DataTable.Filter>

      <TableBrands />
      <Pagination store={store.pagination} />
    </DataTable>
  );
});
